import {
  FiClipboard,
  FiCreditCard,
  FiFolder,
  // FiGrid,
  FiLayers,
  FiSettings,
  FiUsers,
} from "react-icons/fi";

const navItems = [
  // { to: "/", label: "Dashboard", icon: FiGrid },
  { to: "/users", label: "Users", icon: FiUsers },
  { to: "/projects", label: "Projects", icon: FiFolder },
  { to: "/industries", label: "Industries", icon: FiLayers },
  { to: "/transactions", label: "Transactions", icon: FiCreditCard },
  { to: "/audit-log", label: "Audit Log", icon: FiClipboard },
  { to: "/settings", label: "Settings", icon: FiSettings },
];

export default navItems;
